import { createContext, Dispatch, SetStateAction } from 'react'





type ContextProps = {
  track: string
  country: string
  checked: string[]
  setChecked: Dispatch<SetStateAction<string[]>>
  data: TrackCardFragment[]
  setData: Dispatch<SetStateAction<TrackCardFragment[]>>
}

const defaultValue: ContextProps = {
  checked: [],
  setChecked: () => undefined,
  data: [],
  setData: () => undefined,
  track: '',
  country: '',
}

const Context = createContext<ContextProps>(defaultValue)

export { Context }
